enum PathFindingAlgo {
  LightDevops = 'Light Devops Alogrithm',
  Dijkstra = 'Dijkstra',
}

export default PathFindingAlgo;
